import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';

type UpdateAccountNameInput = {
  accountId: string;
  name: string;
};

type UpdatedAccount = {
  id: string;
  name: string;
  organizationId: string;
  createdAt: string;
  updatedAt: string;
};

const fetcher = async (
  _key: string,
  { arg }: { arg: UpdateAccountNameInput }
): Promise<UpdatedAccount> => {
  const { accountId, ...body } = arg;
  return await denApi.patch<UpdatedAccount, typeof body>(
    `admin/multichain-account/${accountId}/name`,
    body
  );
};

export function useUpdateAccountName(
  swrOptions?: SWRMutationConfiguration<
    UpdatedAccount,
    Error,
    string,
    UpdateAccountNameInput
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    UpdatedAccount,
    Error,
    string,
    UpdateAccountNameInput
  >('admin/multichain-account/update-name', fetcher, swrOptions);

  return { updateAccountName: trigger, isLoading: isMutating, error };
}
